import {
  SEND_NOTIFICATION,
  SEND_NOTIFICATION_SUCCESS,
  SEND_NOTIFICATION_ERROR,
  TOGGLE_NOTIFICATION_MODAL,
  SEND_NOTIFICATION_V2,
  SEND_NOTIFICATION_V2_SUCCESS,
  SEND_NOTIFICATION_V2_ERROR,
} from "./actionTypes";

const initialState = {
  sendingNotification: false,
  sendingNotificationSuccess: false,
  sendingNotificationError: null,
  notification: {},
};

const notifications = (state = initialState, action) => {
  switch (action.type) {
    case SEND_NOTIFICATION:
    case SEND_NOTIFICATION_V2:
      state = {
        ...state,
        sendingNotification: true,
        sendingNotificationSuccess: false,
        sendingNotificationError: null,
      };
      break;
    case SEND_NOTIFICATION_SUCCESS:
    case SEND_NOTIFICATION_V2_SUCCESS:
      state = {
        ...state,
        sendingNotification: false,
        sendingNotificationSuccess: true,
        sendingNotificationError: null,
        notification: {},
      };
      break;
    case SEND_NOTIFICATION_ERROR:
    case SEND_NOTIFICATION_V2_ERROR:
      state = {
        ...state,
        sendingNotification: false,
        sendingNotificationSuccess: false,
        sendingNotificationError: action.payload,
      };
      break;
    case TOGGLE_NOTIFICATION_MODAL:
      state = {
        ...state,
        notification: {},
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default notifications;
